<template>
	<div class="form-group health-reports-files">
		<error-box v-if="error" :error="error"/>
		<input type="file" id="file" name="file" @change="filesChange($event.target)" ref="input_file" class="input-file">
		<div class="idi-table table-attachments" v-if="attachment">
			<div class="idi-header">
				<div class="idi-cell">{{ $t('labels.general.file') }}</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row">
				<div class="idi-cell">
					<span v-if="metadata" class="filename">{{ metadata.name }}</span>
				</div>
				<div class="idi-cell align-right no-padding">
					<spinner v-if="!metadata"/>
					<button-icon-loading v-else @click.native.prevent="downloadAttachment()" icon="download"/>
					<button-icon-loading @click.native.prevent="deleteAttachment()" icon="trash" class="btn-delete"/>
				</div>
			</div>
		</div>
		<div v-if="!attachment" class="no-attachments">
			<shape src="/static/svg/files/attachment.svg"/>
			<p>{{ $t('messages.general.no_attachments') }}</p>
		</div>
		<div id="dropzone" ref="dropzone"><div class="message">{{ $t('messages.general.drop_files_here') }}</div></div>
	</div>
</template>

<script>
export default {
	props: [
		'value',
		'user_uid',
		'watch_id',
		'active'
	],
	data () {
		return {
			error: null,
			file: null,
			metadata: null,
			uploading: false
		}
	},
	computed: {
		attachment: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	},
	watch: {
		attachment () {
			this.getAttachmentMetadata()
		},
		uploading (value) {
			this.$emit('uploading', value)
		}
	},
	methods: {
		filesChange (target) {
			Array.from(Array(target.files.length).keys()).map(i => {
				this.uploadFile(target.files[i])
			})
			target.value = ''
		},
		uploadFile (file) {
			this.uploading = true
			this.$api.files.upload(this, this.user_uid, this.watch_id, file)
				.then(response => {
					this.$log.info('watch medicaldocuments', 'files.upload OK', response)()
					this.attachment = response.body.uid
					this.metadata = response.body
				}).catch(errors => {
					this.$log.error('watch medicaldocuments', 'files.upload ERROR', errors)()
					this.error = errors
				}).finally(() => {
					this.uploading = false
				})
		},
		deleteAttachment () {
			if (confirm('Delete?')) {
				this.attachment = null
				this.metadata = null
			}
		},
		getAttachmentMetadata () {
			this.$api.files.getMetadata(this, this.user_uid, this.watch_id, this.value)
				.then(response => {
					this.$log.info('watch medicaldocuments', 'files.getMetadata OK', response)()
					this.metadata = response.body
				}).catch(errors => {
					this.$log.error('watch medicaldocuments', 'files.getMetadata ERROR', errors)()
				})
		},
		downloadAttachment () {
			this.$api.files.get(this, this.user_uid, this.watch_id, this.metadata.uid)
				.then(response => {
					this.$log.info('watch medicaldocuments', 'files.get OK', response)()
					var arrayBuffer = response.body
					var blob = new Blob([arrayBuffer], { type: 'application/download' })
					let link = document.createElement('a')
					link.href = window.URL.createObjectURL(blob)
					link.download = this.metadata.name
					link.click()
				}).catch(errors => {
					this.$log.error('watch medicaldocuments', 'files.get ERROR', errors)()
				})
		},
		showDropZone (e) {
			//console.log('showDropZone', e)
			if (this.active) {
				this.$refs.dropzone.style.visibility = 'visible'
			}
		},
		hideDropZone (e) {
			//console.log('hideDropZone', e)
			this.$refs.dropzone.style.visibility = 'hidden'
		},
		allowDrag (e) {
			//console.log('allowDrag', e)
			if (this.active && true) { //todo: test if item beingdragged is valid
				e.preventDefault()
				e.dataTransfer.dropEffect = 'copy'
			}
		},
		handleDrop (e) {
			//console.log('handleDrop', e)
			e.preventDefault()
			if (this.active) {
				this.hideDropZone()
				let files = e.dataTransfer.files
				for (let i = 0; i < files.length; i++) {
					this.uploadFile(files[i])
				}
			}
		}
	},
	mounted () {
		if (this.attachment) {
			this.getAttachmentMetadata()
		}
		const dropzone = this.$refs.dropzone
		window.addEventListener('dragenter', this.showDropZone)
		dropzone.addEventListener('dragenter', this.allowDrag)
		dropzone.addEventListener('dragover', this.allowDrag)
		dropzone.addEventListener('dragleave', this.hideDropZone)
		dropzone.addEventListener('drop', this.handleDrop)
	},
	beforeDestroy () {
		const dropzone = this.$refs.dropzone
		window.removeEventListener('dragenter', this.showDropZone)
		dropzone.removeEventListener('dragenter', this.allowDrag)
		dropzone.removeEventListener('dragover', this.allowDrag)
		dropzone.removeEventListener('dragleave', this.hideDropZone)
		dropzone.removeEventListener('drop', this.handleDrop)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/medicaldocuments/MedicalDocumentFileUpload.vue